
tabButtonsDirective = ($timeout, $document) ->
    "ngInject"

    restrict: 'E'

    link: (scope, element, attrs) ->
        listElement = element.find('ul')[0]
        clickHandler = angular.element("<div class='click-handler'></div>")

        itemCount = ->
            listElement.children.length

        getListSize = ->
            values = (elem.offsetWidth for elem in listElement.children)
            values.reduce(((a, b) -> a + b), 0)

        createClickHandler = ->
            clickHandler.css('width', listElement.offsetWidth + 'px')
            clickHandler.on('click', open)

        destroyClickHandler = ->
            angular.element($document).off('click', documentClick)
            clickHandler.off("click", open)
            clickHandler.remove()

        resize = ->
            element.removeClass('collapsed open')
            destroyClickHandler()

            mySize = element[0].offsetWidth
            listSize = getListSize()

            if mySize < listSize + 24
                element.addClass('collapsed')
                element.append(clickHandler)
                $timeout createClickHandler, 100

        open = ->
            scope.$apply ->
                element.addClass('open')
                angular.element($document).on('click', documentClick)

        documentClick = (event) ->
            if not element[0].contains(event.target)
                scope.$apply resize

        scope.$watch itemCount, resize
        scope.$on('resize', resize)
        scope.$on('$stateChangeSuccess', resize)
        clickHandler.on('click', open)

        $timeout resize

module.directive('tabButtons', tabButtonsDirective)

